import { ITemplates } from "pages/[tenant]/console/components/templates/ConsoleLayout/types";
import { SalesIsNotInPlan } from "pages/[tenant]/console/dashboards/sales/components/templates/SalesIsNotInPlan";

export const templatesRoutesMap: ITemplates = {
  "/dashboards/sales": SalesIsNotInPlan,
};
